import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { BehaviorSubject, combineLatest, switchMap } from 'rxjs';
import { I18nModule } from '../../../../core/i18n';
import { Article } from '../../../../core/model';
import { UrlModule } from '../../../../core/routing';
import { PrincipalConfigurationDirectiveModule } from '../../../directives';
import { PipesModule } from '../../../pipes';
import { ArticleDetailsService } from '../../../services/article-details/article-details.service';
import { GenericLinkModule } from '../../generic-link';

@Component({
  selector: 'py-article-details',
  templateUrl: './article-details.component.html',
  styleUrls: ['./article-details.component.scss'],
  imports: [
    CommonModule,
    PipesModule,
    I18nModule,
    UrlModule,
    GenericLinkModule,
    NzIconModule,
    PrincipalConfigurationDirectiveModule,
  ],
})
export class ArticleDetailsComponent {
  @Input() set article(article: Article) {
    this.article$.next(article);
  }
  @Input() set unitCode(unitCode: string) {
    this.unitCode$.next(unitCode);
  }

  article$ = new BehaviorSubject<Article>(undefined);
  unitCode$ = new BehaviorSubject<string>(undefined);
  articleDetails$ = combineLatest([this.article$, this.unitCode$]).pipe(
    switchMap(([article, unitCode]) => this.articleDetailsService.getArticleDetails(article, unitCode))
  );

  constructor(private articleDetailsService: ArticleDetailsService) {}
}
